/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { TableBody, TableRow } from '@mui/material';
import CustomTableCell from 'components/cmn/CustomTableCell';
import { ICmnTableBodyProps } from 'interface/cmn/commonInfo';
import { SurveyListLatestContent } from 'interface/project/projectInfo';
import { getComparatorAny, hanldeFormatDate, stableSort } from 'libs/mindUtils';

function DiagnosticHistoryTableBody({ loading, rows }: ICmnTableBodyProps<SurveyListLatestContent>): JSX.Element {
  return (
    <>
      {!loading && rows.length === 0 && (
        <TableBody>
          <TableRow>
            <CustomTableCell align="center" colSpan={3} sx={{ border: 'none' }}>
              조회된 데이터가 없습니다.
            </CustomTableCell>
          </TableRow>
        </TableBody>
      )}
      {!loading && rows.length !== 0 && (
        <TableBody>
          {stableSort(rows, getComparatorAny('desc', 'id')).map((row, index) => {
            const labelId = `table-checkbox-${index}`;
            return (
              <TableRow hover tabIndex={-1} key={row.id} id={labelId}>
                <CustomTableCell align="center">{hanldeFormatDate(row.updAt)}</CustomTableCell>
                <CustomTableCell align="center">{row.saveFileName}</CustomTableCell>
                <CustomTableCell align="center">{row.surveyDesc}</CustomTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      )}
    </>
  );
}

export default memo(DiagnosticHistoryTableBody);
